const MeComponent = () => {
    return (
        <>
            <h1>me</h1>
            <p>My name is Johannes Dietze ( <i>lyxt</i> ) and im a web & software developer. Im focused on functional
                backend & software development. <i>Cars</i> are also the thing im most interested in, besides clean &
                functional code, of course :) </p>
            <p>As of today (<i>07.04.25</i>), im a software developer @ <a href={'https://cic.at'}
                                                                           target={'_blank'} rel={'noreferrer'}>cic</a> - a full-service
                agency based in austria, linz - building e-commerce services, landing pages, erp-system implementations,
                mobile apps & much more - check us out!</p>
            <p>I usually spend my free-time playing games on <a
                href={'https://steamcommunity.com/id/datenbank'}>steam</a>, in the gym or hanging out with my friends.
            </p>
            <p>If you want to connect, hit me up with a dm on <a href={'https://www.twitter.com/6lyxt'}>twitter</a>!</p>
        </>
    )
}
export default MeComponent;
